export default __webpack_public_path__ + "static/media/il-borgo-gallery-2-moris-lorenzi.82a3a302.jpg";